import HomeConnectorCard from './HomeConnectorCard';
import React, { Fragment, useEffect, useState } from 'react';

import { Store } from '../store/Store';
import { withRouter } from '../routes/withRouter';
import { PAGE_URLS } from '../routes/routes';
import { CONTACT_EMAIL, CONTACT_PHONE, isExcelConnectorType, orgStillUsesExcel } from '../legacyPolicy';
import MovedCard from './MovedCard';

const Home = () => {
  const store = React.useContext(Store).store;

  const [showLoader, setShowLoader] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSelectedOrganisation] = useState(
    store?.organisationSelected?.organisationId
  );

  useEffect(() => {
    setSelectedOrganisation(store?.organisationSelected?.organisationId);
    setShowLoader(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store?.organisationSelected?.organisationId]);

  useEffect(() => {
    setShowLoader(true);
  }, [store?.connectorTypeCacheBust]);

  useEffect(() => {
    if (
      store?.organisationConnectorTypes?.length ||
      store?.connectorTypes?.length
    )
      setShowLoader(false);
  }, [store?.organisationConnectorTypes, store?.connectorTypes]);

  return (
    <div>
      <div className="mb-4" style={{ maxWidth: '32rem' }}>
        <MovedCard />
      </div>
      {!store?.organisationConnectorTypes ? (
        <div className="grid grid-col-5 grid-skeleton">
          <HomeConnectorCard skeleton={true} connectorType={{}} />
        </div>
      ) : (
        store.organisationConnectorTypes.some((c: any) => isExcelConnectorType(c.Type)) &&
        store?.user?.roleLevel <= 3 &&
        (orgStillUsesExcel(store?.organisationSelected?.data?.CompanyName) ? (
          <Fragment>
            <h4 className="page-sub-heading">Your connectors</h4>
            <div className="grid grid-col-5">
              {store.organisationConnectorTypes
                .filter((c: any) => isExcelConnectorType(c.Type))
                .map((connectorType: any) => (
                  <HomeConnectorCard key={connectorType.Id} connectorType={connectorType} to={PAGE_URLS.EXCEL_AREAS} />
                ))}
            </div>
          </Fragment>
        ) : (
          <p>
            According to our records you have migrated to MyApp. If you have any questions, please reach out to{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> directly ({CONTACT_PHONE}).
          </p>
        ))
      )}
      {showLoader && (
        <div className="dashboard__content__loader">
          <svg
            className="spinner primary"
            width="50px"
            height="50px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className="circle"
              fill="none"
              strokeWidth="6"
              strokeLinecap="round"
              cx="33"
              cy="33"
              r="30"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default withRouter(Home);
